<template>
  <v-toolbar
    color="primary"
    fixed
    dark
    app
    >
    <v-toolbar-title class="ml-0 pl-3">
    </v-toolbar-title>
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
      <!--<v-text-field
        flat
        solo-inverted
        prepend-icon="search"
        label="Search"
        class="hidden-sm-and-down"
        >
      </v-text-field>-->
      <v-spacer></v-spacer>

      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
        <!--<v-btn icon flat slot="activator">
        <v-badge color="red" overlap>
          <span slot="badge">3</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
      </v-btn>-->
        <notification-list></notification-list>
      </v-menu>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <!--<v-avatar size="30px">
            <img src="/static/avatar/man_4.jpg" alt="Michael Wang"/>
          </v-avatar>-->
          <v-icon>account_circle</v-icon>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
  </v-toolbar>
</template>
<script>
import NotificationList from '@/components/widgets/list/NotificationList';
import Util from '@/util';
// import axios from 'axios';
import router from "@/router/";
export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
    // router
  },
  data: () => ({
    items: [
      {
        icon: 'account_circle',
        title: 'Cuenta',
        click: () => {
          router.push({ path: '/account' });
        }
      },
      // {
      //   icon: 'settings',
      //   href: '#',
      //   title: 'Settings11',
      //   click: (e) => {
      //     console.log(e);
      //   }
      // },
      {
        icon: 'exit_to_app',
        title: 'Salir',
        click: () => {
          window.getApp.$emit('APP_LOGOUT');
        }
      }
    ],
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    }
  }
};

// export default {
//   name: 'app-toolbar',
//   components: {
//     NotificationList
//   },
//
//   // data: () => ({
//   //   items: [
//   //     {
//   //       icon: 'account_circle',
//   //       href: '#',
//   //       title: 'Profile',
//   //       // click: (e) => {
//   //       //   console.log(e);
//   //       // }
//   //     },
//   //     {
//   //       icon: 'settings',
//   //       href: '#',
//   //       title: 'Settings',
//   //       // click: (e) => {
//   //       //   console.log(e);
//   //       // }
//   //     },
//   //     {
//   //       icon: 'fullscreen_exit',
//   //       href: '#',
//   //       title: 'Logout',
//   //     }
//   //   ],
//   // }),
//   data() {
//     return {
//       items: []
//     }
//   },
//   mounted () {
//     axios.get('http://45.7.231.193:8084/api/test/test1').then( response => (this.items = response.data) )
//   },
//   computed: {
//     toolbarColor () {
//       return this.$vuetify.options.extra.mainNav;
//     }
//   },
//   methods: {
//     handleDrawerToggle () {
//       window.getApp.$emit('APP_DRAWER_TOGGLED');
//     },
//     handleFullScreen () {
//       Util.toggleFullScreen();
//     }
//   }
// };

// new Vue({
//   el: '#app',
//   data () {
//     items: []
//   },
//   mounted () {
//     axios
//       .get('https://api.coindesk.com/v1/bpi/currentprice.json')
//       .then(response => (this.info = response))
//   }
// });


// export default {
//   name: 'app-toolbar',
//   components: {
//     NotificationList
//   },
//   data () {
//     items: []
//   },
//   computed: {
//     toolbarColor () {
//       return this.$vuetify.options.extra.mainNav;
//     }
//   },
//   mounted () {
//     axios.get('http://45.7.231.193:8084/api/test/test1').then(response => (this.info = response))
//   },
//   methods: {
//     handleDrawerToggle () {
//       window.getApp.$emit('APP_DRAWER_TOGGLED');
//     },
//     handleFullScreen () {
//       Util.toggleFullScreen();
//     }
//   }
// };



</script>
